var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('views.users.changetracking.title')))]),_c('entity-changetracking-table',{attrs:{"entityBy":_vm.eParent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }